export const environment = {
    production: true,
    backend: 'https://controladorexterno.uv.cl/educacionContinua',
    sentry: {
        dns: 'https://afa3df006d464c83b632bd40266e2343@o560748.ingest.sentry.io/6328470',
        tracingOrigins: ['https://educacioncontinua.uv.cl/'],
    },
    analytics: 'UA-136782505-10',
};
